import * as PropTypes from 'prop-types'
import * as React from 'react'

import { useKeyDown } from '../_shared/hooks/useKeyDown'
import ModalDialog from '../_shared/ModalDialog'

import type { WrapperProps } from './Wrapper'

export interface ModalWrapperProps<T = object> extends WrapperProps<T> {
  /**
   * "OK" label message
   * @default "OK"
   */
  okLabel?: React.ReactNode
  /**
   * "CANCEL" label message
   * @default "CANCEL"
   */
  cancelLabel?: React.ReactNode
  /**
   * "CLEAR" label message
   * @default "CLEAR"
   */
  clearLabel?: React.ReactNode
  /**
   * "TODAY" label message
   * @default "TODAY"
   */
  todayLabel?: React.ReactNode
  /**
   * If true today button will be displayed <b>Note*</b> that clear button has higher priority
   * @default false
   */
  showTodayButton?: boolean
  /**
   * Show clear action in picker dialog
   * @default false
   */
  clearable?: boolean
  /**
   * Props to be passed directly to material-ui Dialog
   * @type {any}
   */
  DialogProps?: any

  children?: React.ReactNode
}

export const ModalWrapper: React.FunctionComponent<ModalWrapperProps<any>> = ({
  open,
  children,
  okLabel = 'OK',
  cancelLabel = 'Cancel',
  showTodayButton = false,
  clearable = false,
  DialogProps,
  showTabs,
  wider,
  InputComponent,
  DateInputProps,
  onAccept,
  onDismiss,
  onSetToday,
  ...other
}) => {
  useKeyDown(open, {
    Enter: onAccept,
  })

  return (
    <React.Fragment>
      <InputComponent {...other} {...DateInputProps} />

      <ModalDialog
        wider={wider}
        showTabs={showTabs}
        open={open}
        onAccept={onAccept}
        onDismiss={onDismiss}
        onSetToday={onSetToday}
        okLabel={okLabel}
        cancelLabel={cancelLabel}
        clearable={clearable}
        showTodayButton={showTodayButton}
        {...DialogProps}
      >
        {children}
      </ModalDialog>
    </React.Fragment>
  )
}

ModalWrapper.propTypes = {
  okLabel: PropTypes.node,
  cancelLabel: PropTypes.node,
  clearLabel: PropTypes.node,
  clearable: PropTypes.bool,
  todayLabel: PropTypes.node,
  showTodayButton: PropTypes.bool,
  DialogProps: PropTypes.object,
} as any
